import {format, differenceInDays} from 'date-fns';
import {__} from './lang/translations.ts';

export function daysFromNow(dateString: string) {
    const date = new Date(dateString);
    const days = differenceInDays(date, new Date());
    if (days === 0) {
        return format(date, 'HH:mm');
    }
    if (days < 0 && days > -7) {
        return Math.abs(days) + 'd';
    }
    return format(date, 'Y-MM-dd');
}

export function formatDate(dateString: string) {
    const date = new Date(dateString);
    return format(date, 'Y-MM-dd');
}

export function getDayName(dateString: string): string {
    const date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    const days = differenceInDays(date, new Date().setHours(0, 0, 0, 0));
    if (days === 0) {
        return 'Vandaag';
    }
    if (days === 1) {
        return 'Morgen';
    }

    return <string>__(`contact.table.days.${date.toLocaleString('en-us', {weekday: 'long'}).toLowerCase()}`);
}
